
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/professional-sellers",
      function () {
        return require("private-next-pages/professional-sellers/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/professional-sellers"])
      });
    }
  